import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectPageType } from 'src/redux/navigation';
import { getProductFieldObject } from 'src/utils/googleAnalytics';
import {
  getProductClickTrackingEvent,
  ProductClickTrackingEvent,
} from '../../../../tracking/events/productClick';
import * as copy from '../constants/copy';

export const getFeaturedProductClickImpression = (
  state: ReduxApplicationState,
): ProductClickTrackingEvent | null => {
  const { products, navigation } = state;
  const { featuredProduct, category, items, productsReturnedCount } = products;
  const { pageType } = navigation;

  if (!featuredProduct) {
    return null;
  }

  return getProductClickTrackingEvent({
    eventCategory: 'Featured Product',
    eventLabel: copy.PRODUCT_LINK,
    actionFieldList: `${selectPageType(state)} - ${category?.name ?? ''} - featured product`,
    products: [
      getProductFieldObject(featuredProduct, items, productsReturnedCount, category, pageType, 1),
    ],
  });
};
